import * as R from 'remeda';

import type { ToastAction, ToastState } from '.';

const initialState: ToastState = [];

// Assigns a fresh UUID on ADD_TOAST — errorWrapper sets id: '' intentionally,
// deferring ID generation to here.
const toastReducer = (
  state: ToastState = initialState,
  action: ToastAction,
): ToastState => {
  switch (action.type) {
    case 'glue/toast/ADD_TOAST':
      return R.take(
        [...state, { ...action.payload, id: crypto.randomUUID() }],
        5,
      );
    case 'glue/toast/DISMISS_TOAST':
      return R.filter(state, (t) => t.id !== action.payload);
    default:
      return state;
  }
};

export default toastReducer;
